function Slick() {
    var self = this;
	this.init();
}

Slick.prototype.init = function() {
	var that = this;
    $('.gallery-ps').each(function(){
        that.createGallerySliders($(this), $(this).siblings('.gallery-thumbs'));
    });
    $('.banner').each(function() {
        that.createBannerSliders($(this).find('.banner-slider-swipe'));
    });
    $('.steps-slider').each(function() {
        that.createStepsSliders($(this));
    });
};

Slick.prototype.createGallerySliders = function(slider, thumbsSlider) {
    $(slider).on('init', function(e, slick, currentSlide, nextSlide) {
        var slides = $(slider).find('.slick-slide:not(.slick-cloned)').length;
        $(slider).siblings('.gallery-ps-counter').find('.slides').html('z '+slides);
        // for (var i = 0; i<slides; i++) {
        //     $(slider).siblings('.gallery-ps-counter').find('.current').append((i+1));
        // }
    });
    $(slider).slick({
        infinite: true,
        autoplay: false,
        accessibility: false,
        swipe: true,
        verticalSwipe: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        arrows: true,
        cssEase: 'cubic-bezier(0,0,0,1)',
        asNavFor: thumbsSlider,
        dots: false
    });
    $(thumbsSlider).slick({
        infinite: true,
        autoplay: false,
        accessibility: false,
        swipe: true,
        verticalSwipe: true,
        speed: 1000,
        swipeToSlide: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                }
            },
        ],
        fade: false,
        arrows: false,
        cssEase: 'cubic-bezier(0,0,0,1)',
        asNavFor: slider,
        dots: false
    });
    $(thumbsSlider).find('.slick-slide').on('click', function(e) {
        e.preventDefault();
        var index = parseInt($(this).attr('data-slick-index'));
        $(thumbsSlider).slick('slickGoTo', index);
        $(slider).slick('slickGoTo', index);
    });
    $(slider).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
        $(slider).siblings('.gallery-ps-counter').find('.current').text(nextSlide+1);
    });
};

Slick.prototype.createBannerSliders = function(slider) {
    var self = this;

    $(slider).on('init', function() {
        var that = $(this);
        
        var currentSlideClass = that.find('.items-container.slick-current').attr('data-body-class');
        $('body').addClass(currentSlideClass);

        that.find('.slick-slide').each(function() {
            $(this).find('.shapes').each(function() {
                $(this).paroller({
                    factorXl: -0.2,
                    factorLg: -0.2,
                    factorMd: 0,
                    factorSm: 0, 
                    factorXs: 0,
                    type: 'foreground'
                });
            });
            $(this).find('.text').each(function() {
                $(this).paroller({
                    factorXl: -0.15,
                    factorLg: -0.15,
                    factorMd: 0,
                    factorSm: 0, 
                    factorXs: 0,
                    type: 'foreground'
                });
            });
            $(this).find('.guy').each(function() {
                $(this).paroller({
                    factorXl: 0.25,
                    factorLg: 0.25,
                    factorMd: 0,
                    factorSm: 0, 
                    factorXs: 0,
                    type: 'foreground'
                });
            });
        });

        var indexAll = $(this).find('.slick-slide:not(.slick-cloned)').length;
        indexAll = (indexAll - 1);
        var index = $(this).find('.slick-current').attr('data-slick-index');
        var slideTitle = $(this).find('.slick-slide[data-slick-index="'+parseInt(indexAll)+'"]').attr('data-title');
        var nextSlideTitle = $(this).find('.slick-slide[data-slick-index="'+(parseInt(index)+1)+'"]').attr('data-title');
        
        if (!that.hasClass('-no-nav')) {
            $('.slick-nav-prev > span').html(slideTitle);
            $('.slick-nav-next > span').html(nextSlideTitle);
        }
        
        that.find('.slick-slide').addClass('-hide');
        that.find('.slick-slide[data-slick-index="'+indexAll+'"]').addClass('-prepareToShow');
        that.find('.slick-current').removeClass('-hide').removeClass('-prepareToShow').addClass('-show');
        setTimeout(function() {
            that.addClass('-visible');
        }, 100);
    });

    $(slider).slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        accessibility: false,
        swipe: true,
        verticalSwipe: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    speed: 500
                }
            }
        ],
        arrows: true,
        cssEase: 'cubic-bezier(0,0,0,1)',
        dots: false
    });

    $('body').on('click', '.slick-nav-prev', function(e) {
        e.preventDefault();
        $(slider).slick('slickPrev');
    });
    $('body').on('click', '.slick-nav-next', function(e) {
        e.preventDefault();
        $(slider).slick('slickNext');
    });

    $(slider).on('afterChange', function(e, slick, currentSlide) {
        var nextSlide;
        var prevSlide;
        if ($(this).find('.slick-slide:not(.slick-cloned)[data-slick-index="'+(currentSlide+1)+'"]').length) {
            nextSlide = currentSlide+1;
        } else {
            nextSlide = 0;
        }
        if ($(this).find('.slick-slide:not(.slick-cloned)[data-slick-index="'+(currentSlide-1)+'"]').length) {
            prevSlide = currentSlide-1;
        } else {
            prevSlide = ($(this).find('.slick-slide:not(.slick-cloned)').length - 1);
        }
        
        var titlePrev = $(this).find('.slick-slide[data-slick-index="'+parseInt(prevSlide)+'"]').attr('data-title');
        var titleNext = $(this).find('.slick-slide[data-slick-index="'+parseInt(nextSlide)+'"]').attr('data-title');
        
        if (!$(slider).hasClass('-no-nav')) {
            $('.slick-nav-prev > span').html(titlePrev);
            $('.slick-nav-next > span').html(titleNext);
        }

        if ($(slider).hasClass('-next')) {
            $(this).find('.slick-slide[data-slick-index="'+nextSlide+'"]').addClass('-prepareToShow');
        } else {
            $(this).find('.slick-slide[data-slick-index="'+prevSlide+'"]').addClass('-prepareToShow');
        }
    });

    $(slider).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
        var currentSlideClass = $(this).find('.slick-slide[data-slick-index="'+currentSlide+'"]').attr('data-body-class');
        var nextSlideClass = $(this).find('.slick-slide[data-slick-index="'+nextSlide+'"]').attr('data-body-class');
        if ($('body').hasClass(currentSlideClass)) {
            $('body').removeClass(currentSlideClass);
        }
        $('body').addClass(nextSlideClass);

        var decl = currentSlide - nextSlide;

        if(decl == 1 || decl == (slick.slideCount-1) * (-1)) {
            $(slider).removeClass('-next').addClass('-prev');
        } else {
            $(slider).removeClass('-prev').addClass('-next');
        }

        $(this).find('.slick-slide[data-slick-index="'+currentSlide+'"]').removeClass('-show').addClass('-hide');
        $(this).find('.slick-slide[data-slick-index="'+nextSlide+'"]').removeClass('-hide').removeClass('-prepareToShow').addClass('-show');
    });
};

Slick.prototype.createStepsSliders = function(slider) {
    var self = this;
    $(slider).on('init', function(e, slick) {
        if ($(slider).find('.slick-current').attr('data-slick-index') == 0) {
            $('section.steps').find('.steps-nav > .prev').addClass('-hidden');
        } else {
            $('section.steps').find('.steps-nav > .prev').removeClass('-hidden');
        }
    });

    $(slider).slick({
        infinite: false,
        autoplay: false,
        accessibility: false,
        swipe: true,
        adaptiveHeight: true,
        verticalSwipe: false,
        speed: 750,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ],
        fade: false,
        arrows: false,
        cssEase: 'cubic-bezier(0,0,0,1)',
        dots: false,
    });
    $('.steps a.next').on('click', function(e) {
        e.preventDefault();
        $(slider).slick('slickNext');
    });
    $('.steps a.prev').on('click', function(e) {
        e.preventDefault();
        $(slider).slick('slickPrev');
    });
    
    if ($(slider).find('.slick-slide:not(.slick-cloned)').length < 3) {
        $('.slider-nav.-large-up').addClass('-hidden');
    }

    if ($(slider).find('.slick-slide:not(.slick-cloned)').length < 2) {
        $('.slider-nav.-medium-down').addClass('-hidden');
    }

    $(slider).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
        if (nextSlide >= 1) {
            $('section.steps').find('.steps-nav > .prev').removeClass('-hidden');
        } else {
            $('section.steps').find('.steps-nav > .prev').addClass('-hidden');
        }

        // if (app.mq == 'large' || app.mq == 'xlarge') {
        //     if (nextSlide == ($(slider).find('.slick-slide:not(.slick-cloned)').length - 2)) {
        //         $('section.steps').find('.steps-nav > .next').addClass('-hidden');
        //     } else {
        //         $('section.steps').find('.steps-nav > .next').removeClass('-hidden');
        //     }
        // } else {
            if (nextSlide == ($(slider).find('.slick-slide:not(.slick-cloned)').length - 1)) {
                $('section.steps').find('.steps-nav > .next').addClass('-hidden');
            } else {
                $('section.steps').find('.steps-nav > .next').removeClass('-hidden');
            }
        // }
    });
};